"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postDistributorFlashOrderFile = exports.POST_FLASH_ORDER_MAX_FILES = void 0;
const routes_1 = require("../../routes");
exports.POST_FLASH_ORDER_MAX_FILES = 5;
// Uses the universal FormData (browser-native + Node 18+ native via undici).
// Axios auto-detects FormData instances and sets the multipart Content-Type with boundary,
// so we don't set headers manually here.
const postDistributorFlashOrderFile = (client) => async ({ distributorId, beneficiaryId, files, additionalText }) => {
    if (!Array.isArray(files) || files.length === 0) {
        throw new Error('postDistributorFlashOrderFile: at least one file is required');
    }
    if (files.length > exports.POST_FLASH_ORDER_MAX_FILES) {
        throw new Error(`postDistributorFlashOrderFile: at most ${exports.POST_FLASH_ORDER_MAX_FILES} files allowed (received ${files.length})`);
    }
    const form = new FormData();
    for (const { file, fileName, mimeType } of files) {
        if (file.type && file.type !== mimeType) {
            throw new Error(`postDistributorFlashOrderFile: blob type "${file.type}" does not match the mimeType "${mimeType}" argument for "${fileName}"`);
        }
        const blob = file.type === mimeType ? file : new Blob([file], { type: mimeType });
        form.append('file', blob, fileName);
    }
    if (additionalText)
        form.append('additionalText', additionalText);
    const url = routes_1.ENDPOINTS.POST_PARTNER_FLASH_ORDER.applyParams({ distributorId });
    const response = await client.post(url, form, {
        headers: { 'x-beneficiary-id': beneficiaryId },
    });
    return response.data;
};
exports.postDistributorFlashOrderFile = postDistributorFlashOrderFile;
